import React from "react"
import styled from "styled-components"
import ReactSlider from 'react-slider'
import { themeColors, responsiveBreakpoints } from "../../theme/themeVariables.js"

const LinearSliderPlayer = ({ handleNext, index, data }) => {
  return (
    <Wrapper>
      <SelectorWrapper>
        <StyledSlider
          className="horizontal-slider"
          onChange={val => handleNext(val)}
          renderTrack={Track}
          renderThumb={Thumb}
          defaultValue={0}
          value={index}
          min={0}
          max={data.length - 1}/>
      </SelectorWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: max-content;
`

const SelectorWrapper = styled.div`
  .number {
    font-family: "saira";
    font-weight: 500;
    font-size: 12px;
    line-height: 0.6em;
  }
`

const StyledSlider = styled(ReactSlider)`
    width: 76vw;
    height: 20px;
    @media (min-width: ${responsiveBreakpoints.desktop}) {
      width: 22vw;
    }
`;

const StyledThumb = styled.div`
    height: 15px;
    line-height: 15px;
    width: 15px;
    text-align: center;
    background-color: ${themeColors.primary};
    color: #fffff;
    border-radius: 50%;
    cursor: grab;
    @media (min-width: ${responsiveBreakpoints.desktop}) {
      height: 20px;
      width: 20px;
    }
`;

const Thumb = (props, state) => <StyledThumb {...props}/>;

const StyledTrack = styled.div`
    bottom: 0;
    background: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px;
    height: 6px;
    transform: translateY(-9px);
    @media (min-width: ${responsiveBreakpoints.desktop}) {
      top: 50%;
      height: 8px;
      transform: translateY(-50%);
    }
`;

const Track = (props, state) => <StyledTrack {...props} index={state.index} />;

export default LinearSliderPlayer
